export default [
    {
      id: 1,
      name: "Creative",
      users:"5",
      description:"Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      created:"11 July 23",
      updated:"11 July 23",
    },
    {
        id: 2,
        name: "Faizan Iqbal",
        users:"3",
        description:"Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        created:"11 July 23",
        updated:"11 July 23",
      },
      {
        id: 3,
        name: "Yumna Zaidi",
        users:"4",
        description:"Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        created:"11 July 23",
        updated:"11 July 23",
      },
  ];
  